import { TeaserEntry } from "../helper/interfaces";
import React, { useState } from "react";
import CustomImage from "./ui/Image";
import { AdInformationInterface } from "../helper/PageInformationInterface";
import TeaserDailyMotionVideoIFrame from "./TeaserDailyMotionVideoIFrame";
import { ContentType, ImageFormat, ImageWidth } from "../helper/enums";
import TeaserVideo from "./TeaserVideo";
import X from "../public/icons/x.svg";
import { PlayCircle } from "react-feather";
import TeaserAdMarker from "./teaserAdMarker";
import { getImageUrlFormat_16_9_600 } from "../helper/images";

export interface TeaserData {
  teaser: TeaserEntry;
  className?: string;
  navigate?: (articleId: string, ressortId: string) => void;
  adInformation?: AdInformationInterface;
  ignoreLead?: boolean;
  isImportantTeaser?: boolean;
  showImage?: boolean;
  showResorts?: boolean;
  isAlreadyLinked?: boolean;
}

function TeaserVideoMinimizedNN(data: TeaserData) {
  const [showVideo, setShowVideo] = useState(false);
  const teaser = data.teaser;

  const image = teaser?.images ? teaser.images[0] : undefined;
  const imageUrl = image ? getImageUrlFormat_16_9_600(image) : null;

  const teaserClassName = `teaser teaser-minimized teaser-minimized-type-${
    teaser.type
  } ${imageUrl ? "teaser--image" : ""} ${
    teaser.featured ? "teaser--featured" : ""
  } ${data.className ? data.className : ""} 
  ${data.isImportantTeaser ? "teaser-minimized__important" : ""}`;

  const resortsData = teaser.ressort?.split(",") || [];

  return (
    <>
      <div
        key={`teaser-link-${teaser.id}`}
        data-name={`article-${teaser.id}`}
        className={teaserClassName}
        onClick={() => {
          setShowVideo(!showVideo);
        }}
      >
        <div>
          {teaser.paid && (
            <div className="flex items-center gap-2 mb-2.5">
              {teaser.paid && !teaser.hidePlusIcon && <div className="linkbox-nn">NN+</div>}
            </div>
          )}
          <div className="flex items-stretch">
            {imageUrl && (
              <div className="teaser-image">
                <div>
                  {data.showImage && image && (
                    <CustomImage
                      src={imageUrl}
                      //fill
                      layout="fill"
                      //height="100%"
                      //width="150px" height="100%"
                      objectFit="cover"
                      alt={image.title}
                    />
                  )}
                  {teaser.paid && !teaser.hidePlusIcon && (
                    <div className="teaser-info">
                      <div className="icon-nnplus" aria-label="NN+"></div>
                    </div>
                  )}
                </div>
                <div className="play-button-overlay">
                  <div className="play-button">
                    <PlayCircle />
                  </div>
                </div>
              </div>
            )}
            <div className="teaser-body flex-1">
              <TeaserAdMarker adIdentifier={teaser.adIdentifier} />
              {teaser.subline && (
                <div className="">
                  <div className="teaser-time">
                    {teaser.subline}
                  </div>
                </div>
              )}

              {teaser.topline && (
                <div className="teaser-info">
                  <div className="teaser-topline">
                    <div>Video {teaser.topline}</div>
                  </div>
                </div>
              )}
              {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}
            </div>
          </div>
        </div>

        {showVideo && (
          <div className="video-overlay">
            <button className="closeButton" onClick={() => setShowVideo(false)}>
              <X class="close-X" />
            </button>
            <div className="video-container">
              <div className="video-wrapper">
                {teaser.type == ContentType.DailyMotionVideo && (
                  <TeaserDailyMotionVideoIFrame teaser={data.teaser} />
                )}
                {teaser.type == ContentType.GlomexVideo && (
                  <TeaserVideo teaser={data.teaser} />
                )}
                {teaser.type == ContentType.Video && (
                  <TeaserVideo teaser={data.teaser} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default TeaserVideoMinimizedNN;
